export default "__VITE_ASSET__BtmKSZTw__"